import React, { DetailedHTMLProps, HTMLAttributes, KeyboardEvent } from "react";
import { joinStrings } from "../../../utils/misc";
import {
  Button,
  Grid,
  Icons,
  Text,
  useToggle,
} from "@pushpress/shared-components";
import WorkingHoursDrawer from "../WorkingHoursDrawer/WorkingHoursDrawer";
import { createWorkingHoursDescription } from "./AvailabilityStart.utils";
import styles from "./WorkingHoursPanel.module.scss";

interface WorkingHoursPanelProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  userUuid: string;
  userName: string;
  workingHours?: {
    dayOfTheWeek: string;
    startTime: string;
    endTime: string;
  }[];
  onSuccess: VoidFunction;
}

const WorkingHoursPanel = (props: WorkingHoursPanelProps) => {
  const { userUuid, userName, workingHours, className, onSuccess, ...other } =
    props;

  const [drawerVisible, drawerActions] = useToggle(false);

  const handleSetup = () => {
    drawerActions.on();
  };

  const handleOpen = () => {
    drawerActions.on();
  };

  const handleKeyOpen = (event: KeyboardEvent) => {
    if (event.key === "Enter") {
      drawerActions.on();
    }
  };

  const handleSuccess = () => {
    drawerActions.off();
    onSuccess();
  };

  const isEmpty = !workingHours?.length;

  return (
    <>
      {isEmpty ? (
        <div {...other} className={joinStrings(styles.root, className)}>
          <Text variant="heading-5" color="wolf-800">
            Working hours
          </Text>
          <Text variant="body-lg" color="wolf-600" className="mt-3">
            Set the days and hours that {userName} is generally available for
            appointment bookings.
          </Text>
          <Button
            buttonType="primary"
            text="Setup"
            fullWidth
            className="mt-3"
            size="large"
            type="button"
            onClick={handleSetup}
          />
        </div>
      ) : (
        <div
          {...other}
          className={joinStrings(styles.rootClickable, className)}
          onClick={handleOpen}
          onKeyDown={handleKeyOpen}
          tabIndex={0}
          role="button"
        >
          <Grid container justifyContent="space-between" spacing={0}>
            <Text variant="heading-5" color="wolf-800">
              Working hours
            </Text>
            <Icons.CaretRight color="#2A3540" className={styles.icon} />
          </Grid>
          <Text variant="body-lg" color="wolf-600" className="mt-3" noWrap>
            {createWorkingHoursDescription(workingHours)}
          </Text>
        </div>
      )}
      <WorkingHoursDrawer
        visible={drawerVisible}
        onClose={drawerActions.off}
        onSuccess={handleSuccess}
        memberId={userUuid}
      />
    </>
  );
};

export default WorkingHoursPanel;
